module.exports = __webpack_public_path__ + "media/images/icons/icon_user-fd3e7f9049ab7d32cae9a673f9824edc.svg";